import Index from '@/pages/user/Index'
import List from '@/pages/user/List'
import Create from '@/pages/user/Create'
import Import from '@/pages/user/Import'
import Modify from '@/pages/user/Modify'
import Reissue from '@/pages/user/Reissue'

var serviceName = process.env.VUE_APP_SERVICE_NAME || 'Nichibyo'

export default {
  path: 'user',
  component: Index,  
  children: [
    {
      path: 'index',
      component: List,
      props: () => ({serviceName: serviceName})
    },
    {
      path: 'create',
      component: Create,
      props: () => ({serviceName: serviceName})
    },
    {
      path: 'import',
      component: Import
    },
    {
      path: 'modify/:id',
      component: Modify,
      props: () => ({serviceName: serviceName})
    },
    {
      path: 'reissue/:id',
      component: Reissue
    },
  ]
}

